import React from 'react'
import {
  SimpleForm,
  Create,
  TextInput,
  TabbedForm,
  List,
  Datagrid,
  TextField,
  EditButton,
  Filter,
  FormTab,
  required,
  DateInput,
  SelectInput,
  BooleanInput,
  ReferenceInput,
  AutocompleteInput,
  DateField,
  Edit
} from 'react-admin'
import { Field } from 'react-final-form'
import DateFilters from '../../elements/DateFilters'

export const Filters = (props) => (
  <Filter {...props}>
    {DateFilters}
  </Filter>
)

export const EventsCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput
          source='title'
          validate={required()}
        />
        <DateInput
          source='date'
          validate={required()}
        />
        <SelectInput
          source='type'
          choices={[
            { id: 'VIDEO', name: 'Video' },
            { id: 'TEXT', name: 'Text' }
          ]}
          validate={required()}
        />
        <ReferenceInput
          source='videoId'
          reference='videos'
          sort={{
            field: 'name',
            order: 'ASC'
          }}
          filterToQuery={searchText => {
            return searchText && {
              'name[$regex]': searchText,
              'name[$options]': 'i'
            }
          }}
          allowEmpty
        >
          <AutocompleteInput
            optionText='name'
            emptyText='clear search'
          />
        </ReferenceInput>
        <TextInput
          source='url'
        />
        <BooleanInput
          source='active'
          defaultValue={true}
        />
      </SimpleForm>
    </Create>
  )
}

export const EventsEdit = (props) => {
  return (
    <Edit {...props}>
      <TabbedForm
        redirect={false}
      >
        <FormTab label='summary'>
          <TextField
            source='_id'
            label='Id'
          />
          <TextInput
            source='title'
            validate={required()}
          />
          <DateInput
            source='date'
            validate={required()}
          />
          <SelectInput
            source='type'
            choices={[
              { id: 'VIDEO', name: 'Video' },
              { id: 'TEXT', name: 'Text' }
            ]}
            validate={required()}
          />
          <ReferenceInput
            source='videoId'
            reference='videos'
            sort={{
              field: 'name',
              order: 'ASC'
            }}
            filterToQuery={searchText => {
              return searchText && {
                'name[$regex]': searchText,
                'name[$options]': 'i'
              }
            }}
            allowEmpty
          >
            <AutocompleteInput
              optionText='name'
              emptyText='clear search'
            />
          </ReferenceInput>
          <TextInput
            source='url'
          />
          <BooleanInput
            source='active'
          />
          <DateField
            source='createdAt'
            label='Created at'
            showTime
          />
          <DateField
            source='updatedAt'
            label='Updated at'
            showTime
          />
        </FormTab>
      </TabbedForm>
    </Edit>
  )
}

export const EventsList = (props) => (
  <List
    {...props}
    filters={<Filters/>}
  >
    <Datagrid>
      <TextField
        source='title'
      />
      <DateField
        source='date'
      />
      <TextField
        source='type'
      />
      <TextField
        source='active'
      />
      <EditButton/>
    </Datagrid>
  </List>
) 